import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Truck } from "lucide-react";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}!`);
      navigate(u.role === "owner" ? "/dashboard/owner" : u.role === "organizer" ? "/dashboard/organizer" : u.role === "admin" ? "/dashboard/admin" : "/explore");
    } catch (err) { toast.error(apiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-20">
      <div className="flex items-center gap-2 justify-center mb-8">
        <span className="w-10 h-10 rounded-full bg-[#0FB5A6] flex items-center justify-center"><Truck className="w-5 h-5 text-white" /></span>
        <span className="font-display font-extrabold text-2xl">FlavorFlow</span>
      </div>
      <div className="bg-white rounded-2xl border border-teal-100 p-8 gr-shadow">
        <h1 className="font-display text-3xl font-black">Welcome back</h1>
        <p className="text-slate-500 mt-1">Log in to your FlavorFlow account.</p>
        <form onSubmit={submit} className="space-y-4 mt-6" data-testid="login-form">
          <div className="space-y-1.5">
            <Label>Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          </div>
          <div className="space-y-1.5">
            <Label>Password</Label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-full h-12 font-bold bg-[#0FB5A6] hover:bg-[#0E9E92] text-white active:scale-95 transition-transform" data-testid="login-submit">
            {loading ? "Logging in…" : "Log in"}
          </Button>
        </form>
        <p className="text-sm text-slate-500 mt-5 text-center">New here? <Link to="/register" className="text-[#0FB5A6] font-bold">Create an account</Link></p>
      </div>
    </div>
  );
}
